import SensorsIntegrationDetailsPanelComponent from './component/IntegrationDetailsPanelComponent';
import { WEB_COMPONENT_SENSORS_INTEGRATION_DETAILS_PANEL } from '../../webcomponents.constants';

export default SensorsIntegrationDetailsPanelComponent;

window.customElements.define(WEB_COMPONENT_SENSORS_INTEGRATION_DETAILS_PANEL, SensorsIntegrationDetailsPanelComponent);
